import React from "react";
import { Icon } from "rhombus-react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";

import { assignLibrary } from "reducers/QA";
import { confirmRemoveAssignee } from "reducers/Confirm";
import QALibraryFilter from "./QALibraryFilter";

export function Actions({ value, dependentValues }){
	const dispatch = useDispatch()
		, { id, userName } = useSelector(state => state.you)
		;

	function assignToMe(e){
		e.preventDefault();
		dispatch(assignLibrary({ id, userName }, [dependentValues.id]));
	}

	function clearAssignment(e){
		e.preventDefault();
		dispatch(confirmRemoveAssignee(assignLibrary, { libraries:[dependentValues]}));
	}

	return (
		<div className="grid-actions flex-center">
			<QALibraryFilter libraryId={dependentValues.id}>
				<Icon name="far fa-folder-open"
					className="qa-action bounce-circle cypress-qa-open-library"
					data-tip="Open Library"
				/>
			</QALibraryFilter>
			<Icon name="far fa-user-check"
				className="qa-action bounce-circle cypress-qa-assign-to-me"
				data-tip="Assign to Me"
				onClick={assignToMe}
			/>
			<Icon name="far fa-user-slash"
				className="qa-action bounce-circle cypress-qa-clear-assignee"
				data-tip="Clear Assignee"
				onClick={clearAssignment}
			/>
			<Link to={{ pathname:`/qa-panel/approvals/${dependentValues.id}/` }}>
				<Icon name="far fa-clipboard-list"
					className="qa-action bounce-circle cypress-qa-view-submission"
					data-tip="View Submission Notes"
				/>
			</Link>
		</div>
	);
}

Actions.displayName = "QAActions";

const QAActions = {
	key: "aid",
	cellClass:"actions-cell qa-actions-cell cypress-qa-actions-cell",
	name: "Actions",
	width:120,
	resizable:false,
	sortable:false,
	formatter:Actions,
	getRowMetaData(data){
		return {
			id:data.id,
			name:data.name,
			assignee:data.assignee,
		};
	},
};

export default QAActions;
